import {Component, Input, OnInit} from '@angular/core';
import {CountDown} from '../../../shared/constants';

@Component({
	selector: 'app-kamona-otp-count-down',
	templateUrl: './kamona-otp-count-down.component.html',
	styleUrls: ['./kamona-otp-count-down.component.scss']
})
export class KamonaOtpCountDownComponent implements OnInit {
	@Input() expiryTime: any;
	@Input() dayId: string;
	@Input() hourId: string;
	@Input() minuteId: string;
	@Input() secondId: string;
	countDown: CountDown;

	constructor() {
	}

	ngOnInit(): void {
		this.countDown = new CountDown(this.expiryTime, this.dayId, this.hourId, this.minuteId, this.secondId);
	}

}
